// signals/authSignal.ts

import { signal } from '@preact/signals-react';

export const SearchSignal = signal<string>('');

export type GlobalStateType = {
  status: 'idle' | 'loading' | 'error' | 'success';
  searchText?: string;
  cypherCode?: string;
};

export const defaultGlobalState: GlobalStateType = {
  status: 'idle' as const,
  searchText: undefined,
  cypherCode: undefined,
};

// Stato dell'utente
export const GlobalStateSignal = signal<GlobalStateType>(defaultGlobalState);

// Stato delle impostazioni
export const settingsState = signal({
  theme: 'light',
  notifications: true,
});

// Tipo per la modale ISac
export type ModalISacType =
  | false
  | 'profile'
  | 'passwordRecovery'
  | 'passwordExpired';

// Signal per la gestione delle modali
export const modalIsacOpen = signal<ModalISacType>(false);

export const toggleModalIsac = (type: ModalISacType = false) => {
  modalIsacOpen.value = type;
};
